export default () => {
    $(document).on('click', '.dropdown-button', function () {
        const _this = $(this);
        const dropdown = _this.closest('.dropdown');
        const dropdownMenu = dropdown.find('.dropdown-menu');
        dropdownMenu.toggleClass('show');
    });

    $(window).on('click', function (event) {
        const target = $(event.target);
        let dropdownButton;
        let dropdown;
        let dropdownMenu;
        if (target.hasClass('dropdown-button') || target.closest('.dropdown-button').length) {
            if (target.hasClass('dropdown-button')) {
                dropdownButton = target;
            } else {
                dropdownButton = target.closest('.dropdown-button');
            }
            if (dropdownButton) {
                dropdown = dropdownButton.closest('.dropdown');
                if (dropdown) {
                    dropdownMenu = dropdown.find('.dropdown-menu');
                }
            }
            $.each($('.dropdown-menu'), function (index, el) {
                el = $(el);
                if (el[0] !== dropdownMenu[0]) {
                    el.removeClass('show');
                }
            });
        } else {
            $('.dropdown-menu').removeClass('show');
        }
    });

}
